import { render, staticRenderFns } from "./tableColumn.vue?vue&type=template&id=3b04be02&scoped=true&"
import script from "./tableColumn.vue?vue&type=script&lang=js&"
export * from "./tableColumn.vue?vue&type=script&lang=js&"
import style0 from "./tableColumn.vue?vue&type=style&index=0&id=3b04be02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04be02",
  null
  
)

export default component.exports